import React from 'react';
import { View, Text, StyleSheet, Image, TouchableOpacity } from 'react-native';
import { withRouter } from "react-router-dom";
import moment from 'moment';

import get from "../../api/methods/get";
import { GET_DISPLAY_BY_EMAIL } from "../../api/userEndpoints";
import { stringIsEmpty } from "../../constants/StringChecker";

import {Card, ImageDisplay, UserAvatar} from '../../components';
import {POST_ADD_LIKE, GET_CHECK_LIKE, POST_REMOVE_LIKE, MURAL_GET_IMAGE} from "./api/muralEndpoints";
import LikeIndicator from "./components/LikeIndicator";
import UtilityBar from "../content/previews/UtilityBar";

class PostComponent extends React.Component {

    state = {
        userAvatarData: null,
        userNickname: '',
        isSending: false,

        updatePostLike: null,
    };

    //TODO(Celso): This can be extact to a method!
    getInformation = async () => {
        try {

            const userId = this.props.userId;
            let userData = await get(GET_DISPLAY_BY_EMAIL(userId), this.props.authToken);
            let userJson = await userData.json();

            this.setState({
                userNickname: userJson.data.nickname,
                userAvatarData: userJson.data.avatarImage
            });

        } catch (e) {
            console.log(e);
        }
    };

    renderBottomContainer = () => {

        let { comments, renderComment } = this.props;
        comments = (comments === undefined || comments === null) ? 0 : comments;

        const {postId, currentUserId, numberOfLikes, answerToId} = this.props;

        return (
            <View>
                <View style={[styles.likesViewStyle, { justifyContent: renderComment ? 'space-around' : 'flex-end' }]}>
                    <LikeIndicator
                        endpointToCheckForLike={GET_CHECK_LIKE(postId, currentUserId)}
                        endpointToSendLike={POST_ADD_LIKE}
                        payloadToAddLike={{
                            postId: postId,
                            userId: currentUserId,
                            answerToId: answerToId,
                        }}
                        endpointToRemoveLike={POST_REMOVE_LIKE}
                        payloadToRemoveLike={{
                            postId: postId,
                            userId: currentUserId,
                            answerToId: answerToId,
                        }}
                        numberOfLikes={numberOfLikes}
                    />

                    {
                        this.props.renderComment === true &&
                            <TouchableOpacity
                                style={{ alignItems: 'center', flexDirection: 'row'}}
                                onPress={() => this.props.history.push('/mural/comments', { answerToId: this.props.postId, postData: this.props.postData })}
                            >
                                <Image
                                    style={{ height: 15, width: 15, tintColor: 'white' }}
                                    resizeMode={'contain'}
                                    source={require('./img/comment/CommentIcon.png')}
                                />

                                <Text style={{ fontSize: 12, color: 'white', marginLeft: 8 }}>
                                    { comments }
                                </Text>
                            </TouchableOpacity>
                    }

                </View>
            </View>
        );
    };

    componentDidMount() {
        this.getInformation();
    };

    render() {

        const { createdAt, creatorId, creatorName, creatorAvatarColor, postImage, postText, } = this.props;
        const date = moment(createdAt);
        const timeDate = date.format('DD/MM/YYYY') + ' - ' + date.format('LT');

        const userNickname = stringIsEmpty(this.state.userNickname) === false ? this.state.userNickname : creatorName;

        return (
            <View style={{ borderWidth: 0.4, padding: 18, borderColor: 'gray' }}>
            	<View style={{flexDirection: 'row', }}>
	                <View style={{ margin: 10 }}>
	                    <UserAvatar
	                        userAvatarColor={creatorAvatarColor}
	                        userAvatarData={this.state.userAvatarData}
	                        userEmail={creatorId}
	                        userName={creatorName}
	                    />
	                </View>

	                <View style={{ flex: 1 }}>
	                    <View style={styles.userDetailsContainerStyle}>
	                        <Text style={styles.userNameTextStyle}>
	                            {userNickname}
	                        </Text>
	                        <Text style={styles.dateTextStyle}>
	                            {' - ' + timeDate}
	                        </Text>
	                    </View>

	                    <View style={styles.descriptionViewStyle}>

	                        <Text style={styles.descriptionTextStyle}>
	                            {postText}
	                        </Text>
	                        {
                                    postImage === true &&
                                    <ImageDisplay
                                        imageUrl={MURAL_GET_IMAGE(this.props.SK)}
                                        propsImageStyle={{ height: 250, width: '100%' }}
                                        propsContainerStyle={{ height: 250, width: '100%' }}
                                    />
	                        }
	                    </View>

                        {this.renderBottomContainer()}

	                </View>

            	</View>

                {/*<View style={{ width: '100%' }}>*/}
                {/*    <UtilityBar onRemove={() => this.props.handleDelete(this.props.postId)} />*/}
                {/*</View>*/}


            </View>
        )
    }
}

const styles = StyleSheet.create({
    mainContainerStyle: {
        margin: 20,
        width: 320,
        marginBottom: 6,
        marginTop: 6
    },
    userDetailsContainerStyle: {
        flexDirection: 'row',
        marginTop: 15,
        alignItems: 'center'
    },
    userNameTextStyle: {
        fontWeight: 'bold',
        fontSize: 14,
        flexWrap: 'wrap',
        color: 'white'
    },
    dateTextStyle: {
        fontStyle: 'italic',
        fontSize: 10,
        flexWrap: 'wrap',
        color: 'white'
    },
    descriptionViewStyle: {
        flexDirection: 'column',
        marginTop: 4,
        marginBottom: 12,
        flexWrap: 'wrap',
    },
    descriptionTextStyle: {
        fontSize: 14,
        marginTop: 4,
        width: '90%',
        textAlign: 'left',
        flexWrap: 'wrap',
        textAlignVertical: 'top',
        color: 'white'
    },
    likesViewStyle: {
    	width: '100%',
    	flexDirection: 'row',
    	height: 30,
        alignItems: 'center',
    	justifyContent: 'space-around',
    },
});

export default withRouter(PostComponent);
